export const NotFound = () => <div>Cannot find the page you are looking for</div>;
